import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// const baseUrl:string=environment.baseUrl;
const baseUrl=environment.baseUrl
@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private http:HttpClient
  ) { }

  getNotificationGroupsList(filters:any):Observable<any>{
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/notification-groups/`,{params})
  }

  getNotificationGroupDetail(groupId:any):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/notification-groups/${groupId}/`)
  }

  getEmailTemplatesList(filters):Observable<any>{
    let params= new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/email-templates/`,{params})
  }

  createEmailTemplate(filters):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/email-templates/`,filters)
  }

  editEmailTemplate(id,filters):Observable<any>{
    return this.http.patch<any>(`${baseUrl}/notification-system/email-templates/${id}/`,filters)
  }

  getEmailTemplateDetail(id):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/email-templates/${id}/`)
  }

  getEventsList(filters):Observable<any>{
    let params= new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/notification-events/`,{params})
  }

  getEventDetails(id: number): Observable<any> {
    return this.http.get(`${baseUrl}/notification-system/notification-events/${id}/`);
  }

  broadCastMessage(eventId:any):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/notification-events/${eventId}/broadcast-message/`,{})
  }

  getNotificationEventDetail(eventId:any):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/notification-events/${eventId}/`)
  }

  createNotificationEvent(filters:any):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/notification-events/`,filters)
  }

  editNotificationEvent(filters:any,id:any):Observable<any>{
    return this.http.patch<any>(`${baseUrl}/notification-system/notification-events/${id}/`,filters)
  }

  getSmtpProviderList():Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/smtp-providers/`)
  }

  getOutgoingMessageList(filters):Observable<any>{
    let params= new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/outgoing-messages/`,{params})
  }

  getOutgoingMessageDetail(messageId):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/outgoing-messages/${messageId}/`)
  }

  getOfficesList(filters):Observable<any>{
    let params= new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/reports/dashboard/offices-list/`,{params})
  }

  createNotificationGroup(parameters:any):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/notification-groups/`,parameters)
  }

  updateNotificationGroup(groupId:any,parameters:any):Observable<any>{
    return this.http.put<any>(`${baseUrl}/notification-system/notification-groups/${groupId}/`,parameters)
  }

  getNotificationContactsList(filters:any):Observable<any>{
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/contacts/`,{params})
  }

  getNotificationContactDetail(contactId:any):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/contacts/${contactId}/`)
  }

  createNotificationContact(parameters:any):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/contacts/`,parameters)
  }

  updateNotificationContact(contactId:any,parameters:any):Observable<any>{
    return this.http.patch<any>(`${baseUrl}/notification-system/contacts/${contactId}/`,parameters)
  }

  getNotificationContactsGroupsList(filters:any):Observable<any>{
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<any>(`${baseUrl}/notification-system/contact-groups/`,{params})
  }

  
  getNotificationContactGroupDetail(contactGroupId:any):Observable<any>{
    return this.http.get<any>(`${baseUrl}/notification-system/contact-groups/${contactGroupId}/`)
  }

  updateNotificationContactGroup(contactGroupId:any,parameters:any):Observable<any>{
    return this.http.put<any>(`${baseUrl}/notification-system/contact-groups/${contactGroupId}/`,parameters)
  }

  createNotificationContactGroup(parameters:any):Observable<any>{
    return this.http.post<any>(`${baseUrl}/notification-system/contact-groups/`,parameters)
  }

}
